import {IS_IOS} from '@ui/utils/platform';

/** Tiny silent WAV — keeps WebKit media session alive for YouTube on iOS. */
const SILENT_AUDIO_SRC =
  'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAZGF0YQAAAAA=';

let keepaliveAudio: HTMLAudioElement | null = null;

export function getIosBackgroundKeepaliveAudio(): HTMLAudioElement | null {
  if (!IS_IOS || typeof document === 'undefined') {
    return null;
  }

  if (!keepaliveAudio) {
    const audio = document.createElement('audio');
    audio.loop = true;
    audio.preload = 'auto';
    audio.src = SILENT_AUDIO_SRC;
    audio.setAttribute('playsinline', 'true');
    audio.setAttribute('webkit-playsinline', 'true');
    audio.style.cssText =
      'position:fixed;left:0;bottom:0;width:1px;height:1px;opacity:0;pointer-events:none';
    document.body.appendChild(audio);
    keepaliveAudio = audio;
  }

  return keepaliveAudio;
}

/** Call during a user gesture (e.g. play tap) so iOS grants background audio. */
export function primeIosBackgroundKeepalive(): void {
  getIosBackgroundKeepaliveAudio()
    ?.play()
    .catch(() => {});
}

export function syncIosBackgroundKeepalive(shouldPlay: boolean): void {
  const audio = getIosBackgroundKeepaliveAudio();
  if (!audio) return;

  if (shouldPlay) {
    audio.play().catch(() => {});
  } else if (!audio.paused) {
    audio.pause();
  }
}

export function destroyIosBackgroundKeepalive(): void {
  if (!keepaliveAudio) return;
  keepaliveAudio.pause();
  keepaliveAudio.remove();
  keepaliveAudio = null;
}
